import { SHOW_MESSAGE, HIDE_HEADER_FOOTER } from "../../constants/ActionTypes";

export const fetchSuccess = (message) => {
  return (dispatch) => {
    dispatch({
      type: SHOW_MESSAGE,
      payload: message || "",
    });
  };
};

export const swich_Header_FooterVisibility = (visibility) => {
  return (dispatch) => {
    dispatch({
      type: HIDE_HEADER_FOOTER,
      payload: visibility,
    });
  };
};
